import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=dc196476&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc196476",
  null
  
)

export default component.exports